// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

// Initialize the Intro and Zitat Sliders
jQuery(function ($) {
  new Swiper('.swiper', {
    autoplay: {
      delay: 7000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
    direction: 'horizontal',
    loop: true,
    speed: 700,

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    modules: [Autoplay, Pagination],
  });
});
